<script lang="ts">
    import {
        Button,
        StructuredList, 
        StructuredListHead, 
        StructuredListBody, 
        StructuredListRow, 
        StructuredListCell,
        InlineLoading,
    } from "carbon-components-svelte"
    import SelectBuilding from "./SelectBuilding.svelte";
    import type {Requests} from "../libreries/Requests";
    import {selectedTenant, selectedBuilding, gates} from "../stores";
    import type { Building } from "../models/Building";
    import { onMount } from "svelte";
    import type { Presence } from "../models/Presence";
    import type { Tenant } from "../models/Tenant";
    import { Helpers } from "../utilities/Helpers";
    import type { Gate } from "../models/Gate";
    import moment from "moment";
    
    export let requests: Requests;
    let building: Building;
    let presences: Presence[] = [];
    let tenant: Tenant;
    let promise: Promise<any>;
    //let buildingGates: Gate[] = []

    onMount(() => {
        selectedTenant.subscribe((value) => {
            tenant = value;
        })
        selectedBuilding.subscribe((value) => {
            building = value;
            if(building){
                if(building.id !== ""){
                    promise = getPresences();
                }
            }
        })
        // gates.subscribe((value) => {
        //     buildingGates = value;
        // })
    })

    async function getPresences(){
        presences = await requests.getBuildingPresences(tenant.id, building.id);
    }

</script>

<SelectBuilding requests={requests} />
{#if building}
    {#if building.id === ""}
        <h6 class="margin-top-32">Selezionare un building</h6>
    {:else}   
        <div class="pdf-content">
            <h4 class="margin-top-64 margin-bottom-16">
                Presenze nel building {building.name}, il {(moment(new Date())).format('DD-MMM-YYYY HH:mm:ss')}
            </h4>
            <StructuredList>
                <StructuredListHead>
                <StructuredListRow head class="header-row">
                    <StructuredListCell head>Data</StructuredListCell>
                    <StructuredListCell head>Nome</StructuredListCell>
                    <StructuredListCell head>Tipologia</StructuredListCell>
                    <StructuredListCell head>Orario ingresso</StructuredListCell>
                    <StructuredListCell head>Gate ingresso</StructuredListCell>
                </StructuredListRow>
                </StructuredListHead>
                <StructuredListBody>
                    {#await promise}
                        <InlineLoading />
                    {:then}
                        {#if presences}
                            {#if presences.length > 0}
                                {#each presences as presence, index}
                                <StructuredListRow class={index%2 === 0 ? "even-row" : ""}>
                                    <StructuredListCell>{presence.dateIn}</StructuredListCell>
                                    <StructuredListCell>{presence.identity}</StructuredListCell>
                                    <StructuredListCell>{Helpers.switchUserType(presence.identityType)}</StructuredListCell>        
                                    <StructuredListCell>{presence.timeIn}</StructuredListCell>
                                    <StructuredListCell>{presence.gateIn}</StructuredListCell>
                                </StructuredListRow>
                                {/each}  
                            {:else}
                                <h6 style="margin: 2rem">Nessuna presenza</h6>
                            {/if}
                        {/if}
                    {/await}    
                </StructuredListBody>
            </StructuredList>
        </div>
        <Button on:click={() => Helpers.exportToPDF(building.id)} id="cmd">Salva in PDF</Button>          
    {/if}
{:else}
    <h6 class="margin-top-32">Selezionare un building</h6>
{/if}